import React from "react";
import {Popconfirm, Tooltip, Typography} from "antd";
import { PushpinOutlined, InfoCircleOutlined, StarOutlined, StarFilled } from "@ant-design/icons";

import {formatCompanyLogoUrl} from "../../../../api/companyApi";
import Logo from "../../../../components/Graphics/Logo";
import TargetAllocations from "../../../../components/TargetAllocations";
import {DoubleLine} from "../../../../components/Labels";
import TimeCell from "../../../../components/TimeCell";
import {PORTFOLIO_TYPES} from "../usePortfolios";
import PortfolioRowMenu from "./PortfolioRowMenu";
const {Link} = Typography;





const FavoriteStar = ({ id, isStarred, toggleFavorite }) => {
    return isStarred ? (
    <Popconfirm
      title="Are you sure you want to remove this from favorites?"
      onConfirm={() => toggleFavorite(id, false)}
      okText="Yes"
      cancelText="No"
    >
      <StarFilled style={{ color: 'var(--color-primary)', cursor: 'pointer', fontSize: '18px' }} />
    </Popconfirm>
  ) : (
    <Popconfirm
      title="Are you sure you want to add this to favorites?"
      onConfirm={() => toggleFavorite(id, true)}
      okText="Yes"
      cancelText="No"
    >
      <StarOutlined style={{ cursor: 'pointer', fontSize: '18px', color: '#B6C7D6' }} />
    </Popconfirm>
  );
}

/**
 *
 * @param handleEdit
 * @param toggleFavorite
 * @param prefix {string, optional} if provided, is a string to prefix the portfolio name with
 * @returns {[{title: string, render: (function(*, *): JSX.Element), key: string},{title: string, render: (function(*, *)), key: string},{title: string, render: (function(*, *)), key: string},{title: string, render: (function()), key: string},{dataIndex: string, title: string, key: string},null,null,null,null,null,null,null,null,null]}
 * @constructor
 */
const configureTableColumns = ({
                               handleEdit,
                               toggleFavorite,
                               prefix,

})=>{


    const formatPortfolioTitle = (title)=>{
        if (prefix){
            return `${prefix} ${title}`;
        }
        return title;
    }

    return [
        {
            title: <Tooltip><InfoCircleOutlined size={16}/> </Tooltip>,
            key: 'action',
            render: (_, record) => (
                <PortfolioRowMenu
                    onEdit={() => handleEdit(record.id)}
                    portfolio={record}
                />
            ),
            align: 'center'
            // fixed: 'left',
            // width: 75,
        },
        {
            title: <Tooltip title={'Pin to Favorites'}><PushpinOutlined /></Tooltip>,
            key: 'favorite',
            render: (_, record) => <FavoriteStar id={record.id} isStarred={record._user?.in_use} toggleFavorite={toggleFavorite} />,
            align: 'center'
        },
        {
            title: 'Company',
            key: 'logo',
            render: (_) => <Logo src={formatCompanyLogoUrl()} height={'55px'} width={'55px'} />,
            align: 'center',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <Tooltip title={text}>
                    <DoubleLine
                        title={formatPortfolioTitle(text)}
                        text={PORTFOLIO_TYPES?.[record?.type] ?? ''}
                        titleSize={'12px'}
                    />
                </Tooltip>
            ),
            onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
            searchable: true
        },
        {
          title: "Targets",
          dataIndex: ['targets', 'equity'],
          key: 'targets',
          render: (_, record)=> <TargetAllocations equity={record?.targets?.equity} fixed={record?.targets?.fixed} />,
            align: 'center'
        },
        {
          title: 'Created',
          dataIndex: ['_meta', 'create_unix'],
          key: ['_meta', 'create_unix'],
          render: (timestamp, record) => {
            return <TimeCell timestamp={timestamp}  />
          },
          sorter: (a, b) => new Date(b?._meta?.create_unix) - new Date(a?._meta?.create_unix),
        },
        {
          title: 'Updated',
          dataIndex: ['_meta', 'update_unix'],
          key: ['_meta', 'update_unix'],
          render: (timestamp, record) => {
            return <TimeCell timestamp={timestamp} />
          },
          sorter: (a, b) => new Date(b?._meta?.create_unix) - new Date(a?._meta?.create_unix),
        },
        {
          title: 'Benchmark',
          dataIndex: 'benchmark',
          key: 'benchmark',
          render: (benchmark) => {
              return <Link style={{fontSize: '14px'}}>{benchmark?.toUpperCase?.()??''}</Link>
          },
            align: 'center'
        },
    ];
}

export default configureTableColumns;